import Vue from 'vue'
import App from './App.vue'
import store from "./store"
import controls from './assets/js/controls';
import sliders from './assets/js/sliders';

Vue.config.productionTip = false

const app = new Vue({
  store,
  render: h => h(App),
}).$mount('#app');

app.$nextTick(() => {
  controls();
  sliders();
});
